import PropTypes from 'prop-types'

// Internal components
import Svg from '../Svg/Svg'

const PlaySymbol = ({ modifiers }) => {
  const modifierClasses = modifiers ? ' ' + modifiers.join(' ') : ''

  return (
    <div className="PlaySymbol-wrapper">
      <div className={`PlaySymbol${modifierClasses}`}>
        <Svg id="icon-play" modifiers={['PlaySymbol-icon']} />
      </div>
    </div>
  )
}

PlaySymbol.propTypes = {
  modifiers: PropTypes.array
}

export default PlaySymbol
